import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPatchSegmentPeople, TSegmentPeople } from '../types';

type TPatchSegmentPeopleBody = {
  id: string;
  body: TPatchSegmentPeople;
  silently?: boolean;
};
export async function patchSegmentPeople({
  id,
  body,
}: TPatchSegmentPeopleBody): Promise<TSegmentPeople> {
  return mediaManagerClient
    .patch(`/api/v1/segment_people/${id}`, emptyStringValues(body))
    .then(response => response as unknown as TSegmentPeople);
}

type MutationFn = typeof patchSegmentPeople;

type TUsePatchSegmentPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchSegmentPeople({ config }: TUsePatchSegmentPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchSegmentPeople,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la persona de interés del segmento'));
      console.error(error);
    },
    onSuccess(_data, variables: TPatchSegmentPeopleBody) {
      if (!variables.silently) {
        addSuccessNotification(
          t('La persona de interés del segmento se ha actualizado correctamente')
        );
      }
    },
  });
}
